var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 79,
    viewBox: "0 0 179 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path-5",
    d: "M168.4 78.5447V14.9759H158.682L160.877 5.23633H178.118V78.5447H168.4Z",
    fill: "url(#paint0_linear_392_47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path-4",
    d: "M138.016 12.1482V2.30398L147.838 0V9.84427L138.016 12.1482ZM138.225 78.5447V28.4855L148.047 26.1816V78.5447H138.225Z",
    fill: "#1E1E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "path-3",
    d: "M123.023 78.6494H132.659L117.716 5.34814H108.08L93.8931 78.6494H96.7954H103.529H116.192L114.71 70.7091H105.065L113.022 29.5989L123.023 78.6494Z",
    fill: "url(#paint1_linear_392_47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "path-2",
    d: "M46.332 78.5447V5.23633H56.0497V54.1435L75.3808 5.23633H85.0985L70.5741 41.8906L85.0985 78.5447H75.3808L65.7675 54.1435L56.0497 78.5447H46.332Z",
    fill: "#1E1E3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    d: "M7.52342 78.5447C5.43358 78.5447 3.65722 77.8117 2.19433 76.3455C0.731444 74.8793 0 73.099 0 71.0044V54.7719L9.71776 56.9711V65.0351C9.71776 66.0823 10.0661 66.9899 10.7627 67.7579C11.529 68.4561 12.3997 68.8052 13.375 68.8052H25.2871C26.332 68.8052 27.2028 68.4561 27.8994 67.7579C28.6656 66.9899 29.0488 66.0823 29.0488 65.0351V46.6032C29.0488 45.556 28.6656 44.6833 27.8994 43.9851C27.2028 43.2171 26.332 42.8331 25.2871 42.8331H7.52342C5.43358 42.8331 3.65722 42.1 2.19433 40.6338C0.731444 39.1677 0 37.3873 0 35.2928V12.7767C0 10.6821 0.731444 8.90175 2.19433 7.43559C3.65722 5.96942 5.43358 5.23633 7.52342 5.23633H31.2431C33.333 5.23633 35.1093 5.96942 36.5722 7.43559C38.0351 8.90175 38.7665 10.6821 38.7665 12.7767V24.0871L29.0488 21.7831V18.7461C29.0488 17.6988 28.6656 16.8261 27.8994 16.1279C27.2028 15.3599 26.332 14.9759 25.2871 14.9759H13.375C12.3997 14.9759 11.529 15.3599 10.7627 16.1279C10.0661 16.8261 9.71776 17.6988 9.71776 18.7461V29.3234C9.71776 30.3707 10.0661 31.2783 10.7627 32.0463C11.529 32.7445 12.3997 33.0936 13.375 33.0936H31.2431C33.333 33.0936 35.1093 33.8266 36.5722 35.2928C38.0351 36.759 38.7665 38.5393 38.7665 40.6338V71.0044C38.7665 73.099 38.0351 74.8793 36.5722 76.3455C35.1093 77.8117 33.333 78.5447 31.2431 78.5447H7.52342Z",
    fill: "#1E1E3E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_392_47",
    x1: 168.401,
    y1: 7.55708,
    x2: 168.401,
    y2: 75.9248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B65F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2944E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_392_47",
    x1: 113.278,
    y1: 7.66867,
    x2: 113.278,
    y2: 76.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B65F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2944E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoading);
export default __webpack_public_path__ + "static/media/logo-loading.f57c4ae0c81f266834c18ebaafe5682d.svg";
export { ForwardRef as ReactComponent };